export default __webpack_public_path__ + "static/media/background.80f511df.svg";